import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import entity_cache from './modules/entity_cache';
import axios from 'axios';
import qs from 'qs';
import VuexORM from '@vuex-orm/core';
import VuexORMAxios from '@vuex-orm/plugin-axios';
import Product from '../models/Product';
import ProductType from '../models/ProductType';
import ProductCategory from '../models/ProductCategory';
import ProductClassification from '../models/ProductClassification';
import Carrier from "../models/Carrier";
import Contact from "../models/Contact";
import Customer from "../models/Customer";
import InsulationCut from "../models/InsulationCut";
import Location from "../models/Location";
import Note from "../models/Note";
import Notification from "../models/Notification";
import Order from "../models/Order";
import OrderContact from "../models/OrderContact";
import OrderItem from "../models/OrderItem";
import OrderLocation from "../models/OrderLocation";
import OrderStatus from "../models/OrderStatus";
import OrderStatusLog from "../models/OrderStatusLog";
import DocumentFolder from "../models/DocumentFolder";
import Document from "../models/Document";
import CustomerContact from "../models/CustomerContact"
import CustomerLocation from "../models/CustomerLocation"
import DocumentAttachment from "../models/DocumentAttachment";
import OrderNote from "../models/OrderNote";
import Employee from "../models/Employee";
import Estimate from "../models/Estimate";
import EstimateItem from "../models/EstimateItem";
import EstimateStatus from "../models/EstimateStatus";
import EstimateStatusLog from "../models/EstimateStatusLog";
import PriceList from "../models/PriceList";
import PriceListItem from "../models/PriceListItem";
import User from "../models/User";
import CarrierContact from "../models/CarrierContact";
import CarrierLocation from "../models/CarrierLocation";
import NotificationMessage from "../models/NotificationMessage";
import KnowledgebaseThread from "../models/KnowledgebaseThread";
import KnowledgebasePost from "../models/KnowledgebasePost";
import Ticket from "../models/Ticket";
import Newsletter from "../models/Newsletter";
import OrderCommit from "../models/OrderCommit";
import CustomerEstimate from "../models/CustomerEstimate";
import CustomerEstimateItem from "../models/CustomerEstimateItem";
import {AUTH_LOGOUT} from './action-types';
import router from '../router'

Vue.use(Vuex);

axios.interceptors.request.use(
  request => {
    if(localStorage.getItem("auth__access_token") !== null) {
      request.headers = request.headers || {};
      request.headers['Authorization'] = 'Bearer ' + localStorage.getItem("auth__access_token");
    }
    request.paramsSerializer = params => {
      return qs.stringify(params);
    };
    return request;
  }
);

VuexORM.use(VuexORMAxios, {
  axios,
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
  baseURL: process.env.VUE_APP_SF_SERVICE_URL + '/api/v1/'
});

const database = new VuexORM.Database();
database.register(Carrier);
database.register(CarrierContact);
database.register(CarrierLocation);
database.register(Contact);
database.register(Customer);
database.register(CustomerContact);
database.register(CustomerLocation);
database.register(CustomerEstimate);
database.register(CustomerEstimateItem);
database.register(Document);
database.register(DocumentAttachment);
database.register(DocumentFolder);
database.register(Employee);
database.register(Estimate);
database.register(EstimateItem);
database.register(EstimateStatus);
database.register(EstimateStatusLog);
database.register(InsulationCut);
database.register(Location);
database.register(KnowledgebaseThread);
database.register(KnowledgebasePost);
database.register(Newsletter);
database.register(Note);
database.register(Notification);
database.register(NotificationMessage);
database.register(Order);
database.register(OrderContact);
database.register(OrderCommit);
database.register(OrderItem);
database.register(OrderLocation);
database.register(OrderNote);
database.register(OrderStatus);
database.register(OrderStatusLog);
database.register(PriceList);
database.register(PriceListItem);
database.register(Product);
database.register(ProductCategory);
database.register(ProductClassification);
database.register(ProductType);
database.register(Ticket);
database.register(User);

const store = new Vuex.Store({
  modules: { auth, entity_cache },
  plugins: [VuexORM.install(database)]
});

axios.interceptors.response.use(
  response => {
    return response;
  }, error => {
    console.log('------------- VUEX RESPONSE ERROR -----------------');
    console.log(error.response.status);
    if((!error.response || [403,401,408].includes(Math.abs(error.response.status)))) {
      store.dispatch(AUTH_LOGOUT);
      router.push('/login');
    }
    if(error && error.response && error.response.data && error.response.data.message) {
      throw error.response.data.message;
    }
    throw error;
  }
);

export default store;
